angular.module 'app'
.controller 'SelectTemplateCtrl', ($scope, $http, $stateParams, $state, config, Storage, dialogs, growl, SweetAlert) ->

  $scope.back = ->
    $state.go('app.pagetemplate')
